/*------------------------------------------------

WARNING: SOME INITIAL WORK WAS DONE FOR MAX UI BUT
INVESTIGATING THEIR USAGE IN DB REVEALED THAT THEY
ARE NOT USING SOME OF THE REQUESTED FEATURES. LEFT
THE WORK IN PLACE IN THE CHANCE THAT THEY WANT IT.

------------------------------------------------*/

import {useState,useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {envAwarePost,capitalize} from '../../util/util'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import {
	getActivityLog,
	clearAllNotifications,
	removeNotification,
	reactInBulk
} from './slice'
import {
	getChatRoom,
	setShow as setShowMessageCenter
} from '../MessageCenter/messageCenterSlice'
import {Link} from 'react-router-dom'
import styles from './NotificationDashboard.module.css'
import {getCurrencySymbol} from '../../util/intl'
import useCurrentUser from '../../hooks/useCurrentUser'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import Reactions from '../reactions/Reactions'
import {getReactionOptions} from '../reactions/reactionsSlice'
import UserThumbnail from '../UserThumbnail/UserThumbnail'
import moment from 'moment'
import EventLink from "../EventLink/EventLink"
import DiscussResourceButton from "../DiscussResourceButton/DiscussResourceButton"

import {useSetProspectViewer} from '../Growth/hooks'


const dateOptions = { 
	year: 'numeric',
	month: '2-digit',
	day: 'numeric',
	hour:'2-digit',
	minute:'2-digit'
}

const RemoveButton = ({id})=>{
	const statusDispatch = useApiStatusDispatch()
	const [status,setStatus] = useState('idle')
	const handleRemove = ()=>{
		setStatus('pending')
		statusDispatch(
			removeNotification(id),
			'notification',
			'remove'
		).then(res=>{
			setStatus('idle')
		})
	}
	return (
		<button 
			style={{
				position:'absolute',
				top:0,
				right:0,
				transform:'translate(50%,-50%)',
				width:'18px',
				height:'18px',
				fontSize:'12px',
				padding:0,
				border:'1px solid rgb(220, 53, 69)',
				background:'#fff',
				color:'rgb(220, 53, 69)',
				borderRadius:'100px',
			}}
			disabled={status==='pending'}
			onClick={handleRemove}
		>
			{status==='pending'?
				<Spinner animation="grow" size="sm"/>
				:
				<i className="fa fa-times"/>
			}
		</button>
	)
}

const Attachment = ({src,mediaType,removed}) => {
	if(removed) return (
		<div>
			<strong>
				<i className={[
					'mr-1',
					mediaType === 'video' ? "fas fa-video-slash" : "fas fa-microphone-slash"
				].join(' ')}/>
				Expired {mediaType} memo
			</strong>
		</div>
	)
	switch(mediaType){
		case 'image': return <img className="w-100 rounded d-block mt-1" src={src} />
		case 'audio': return (
			<div>
				<div>
					<small className="d-block">Voice memo</small>
					<audio title="voice memo" src={src} controls/>
				</div>
			</div>
		)
		case 'video': return (
			<video controls className="w-100 rounded d-block mt-1">
				<source src={src}/>
			</video>
		)
		default: return null
	}
}

const ProgressPic = ({pic})=>{
	const isClient = useCurrentUser().account_type === 'client'
	return (
		<div>
			<div className="mb-1">
				{!isClient?
					<>
						{Boolean(pic.resource.user_profile_pic)&&
							<UserThumbnail src={pic.resource.user_profile_pic}/>
						}
						<strong>{pic.resource.user_name}</strong> added a progress photo
					</>
					:
					<>
						You added a progress photo
					</>
				}
			</div>
			<img className="w-100 d-block rounded" src={pic.resource.img}/>
			<div className="p-2">
				<div className="d-flex align-items-start justify-content-between flex-wrap">
					
				</div>
				<div>
					<small>{pic.resource.caption}</small>
				</div>
				<hr className="my-1"/>
				<div className="d-flex justify-content-between align-items-end">
					<Link 
						to={`/photo_reel?client=${pic.resource.client_id}`}
						target="_blank"
					>
						<small>View Progress</small>
					</Link>
					<small className="d-block text-muted">
						{new Date(pic.datetime.split(' ').join('T')).toLocaleString([],dateOptions)}
					</small>
				</div>
			</div>
		</div>
	)
}

const MiniChat = ({room})=>{
	const dispatch = useDispatch()
	const openChatHandler = () => {
		dispatch(getChatRoom({room_id:room.id}))
		dispatch(setShowMessageCenter(true))
	}
	return (
		<div>
			<div className="d-flex align-items-center justify-content-between">
				<strong>{room.name||'Private Chat'}</strong>
				<OverlayTrigger overlay={
					<Tooltip>Open this chatroom</Tooltip>
				}>
					<Button 
						onClick={()=>{ openChatHandler(room.id) }}
						variant="outline-primary" 
						size="sm"
					>
						<i className="fa fa-comment"/>
					</Button>
				</OverlayTrigger>
			</div>
			<hr className="my-1"/>
			<div>
				{room.messages.map(message=>(
					<div>
						<div className="d-flex align-items-start justify-content-between">
							<div>
								{Boolean(message.author.profile_pic)&&
									<UserThumbnail src={message.author.profile_pic}/>
								}
								<small>
									<strong>
										{message.author.user_name}
									</strong>
								</small>
							</div>
							<small className="text-muted">
								{new Date(message.sent_at.split(' ').join('T')).toLocaleString([],dateOptions)}
							</small>
						</div>
						<Attachment 
							mediaType={message.media_type}
							src={message.attachment}
							removed={Boolean(message.media_removed)}
						/>
						<small className="d-block w-100 my-1">{message.message}</small>
					</div>
				))}
			</div>
		</div>
	)
}

const ChatReaction = ({reaction})=>{
	const iconMap = {
		'thumbs up':'👍',
		'grin-stars':'🤩',
		'grin':'😄',
		'clap':'👏',
		'party':'🎉'
	}
	const dispatch = useDispatch()
	const openChatHandler = () => {
		dispatch(getChatRoom({room_id:reaction.room.id}))
		dispatch(setShowMessageCenter(true))
	}
	return (
		<div>
			<div className="d-flex justify-content-between">
				<div>
					{Boolean(reaction.sender.profile_pic)&&
						<UserThumbnail src={reaction.sender.profile_pic.url}/>
					}
					<strong>{reaction.sender.user_name}</strong> reacted {iconMap[reaction.name]} to:
				</div>
				<OverlayTrigger overlay={
					<Tooltip>Open this chatroom</Tooltip>
				}>
					<Button 
						onClick={openChatHandler}
						variant="outline-primary" 
						size="sm"
					>
						<i className="fa fa-comment"/>
					</Button>
				</OverlayTrigger>
			</div>
			<hr className="my-1"/>
			<small className="d-block">{reaction.content}</small>
		</div>
	)
}

const ChatItem = ({item})=>{
	switch(item.type){
		case 'chat_room': return <MiniChat room={item}/>
		case 'reaction': return <ChatReaction reaction={item}/>
	}
}

const CompletedForm = ({form})=>(
	<div>
		<div className={styles.ItemHeader}>
			{Boolean(form.resource.client.profile_pic)&&
				<UserThumbnail src={form.resource.client.profile_pic}/>
			}
			<strong>{form.resource.client.user_name}</strong> completed form <strong>{form.resource.form_title}</strong>
		</div>
		<hr className="my-1"/>
		<div className="d-flex justify-content-between align-items-end">
			<Link 
				to={`/formEditor?formId=${form.form_id}&clientId=${form.resource.client.user_id_number}`}
				target="_blank"
			>
				<small>view form</small>
			</Link>
			<OverlayTrigger overlay={
				<Tooltip>Discuss this custom form in the chat</Tooltip>
			}>
				<DiscussResourceButton
					className="text-info"
					style={{
						border:'none',
						background:'none'
					}}
					pendingText="linking"
					user_id_number={form.resource.client.user_id_number}
					name={form.resource.form_title}
					id={form.resource.form_id}
					type="custom_form"
				>
					<small>discuss</small>
				</DiscussResourceButton>
			</OverlayTrigger>
			<small className="text-muted">
				{new Date(form.datetime.split(' ').join('T')).toLocaleString([],dateOptions)}
			</small>
		</div>
	</div>
)

const CalendarUpdated = ({event})=>{

	const isTime24Hour = Number(useSelector(state => state.users.current_user.is_24_hour_time))

	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const {text, start_date, client} = event.resource;
	


	const user_name = client.user_name;
	const {update_type, series, requested, calendar_id } = event.resource_meta;
	const isEventMoved = update_type === "moved";
	const isCreated = update_type === "created";

	let date = moment.utc(start_date).local();
	
	date = isTime24Hour ? date.format('YYYY-MM-DD, hh:mm') : date.format('YYYY-MM-DD, hh:mm A')
	


	const renderClientText = () => {
		return <div className={styles.ItemHeader}>
			<strong><span> {Boolean(requested) && !isCreated && "Requested"} Appointment </span>
			{update_type}:</strong> 
			<br/>
			<i>{text}</i>
			{isEventMoved ? " was moved to" : " @ "}
		
			<span> {date}</span>
			
			{!isCreated && !isEventMoved && ` was ${update_type}`}.
			
			{Boolean(series) && <i> This is a recurring appointment. </i>}
		</div>
	}

	const renderTrainerText = () => {
		return <div className={styles.ItemHeader}>
		
			<strong><span> {Boolean(requested) && !isCreated && "Requested"} Appointment </span>
			{`${isCreated ? "requested" : update_type}`} by {user_name}:</strong> 
			<br/>
			<i>{text}</i>
			{isEventMoved ? " was moved to" :
				isCreated ? " requested for" :
				" @ "}

			<span> {date} </span>
			
			{isCreated || isEventMoved ? "and" : ` was ${update_type} and`}
			
			<span> is pending approval</span> 
			
			{Boolean(series) && <i> This is a recurring appointment. </i>}

		</div>
	}



	return (
	<div>
	{isClient ? renderClientText() : renderTrainerText()}

	<hr className="my-1"/>
		<div className="d-flex justify-content-between align-items-end">
			<Link 
				to={`/scheduler?startDate=${date}&id=${calendar_id}`}
				target="_blank"
			>
				<small>View Appointment</small>
			</Link>
			<small className="text-muted">
				{new Date(event.datetime.split(' ').join('T')).toLocaleString([],dateOptions)}
			</small>
		</div>
	</div>)

}

const AddedForm = ({form})=>{
	return (
	<div>
		<div className={styles.ItemHeader}>
			<strong>{form.resource.form_title}</strong> was assigned to you
		</div>
		<hr className="my-1"/>
		<div className="d-flex justify-content-between align-items-end">
			<Link 
				to={`/formEditor?formId=${form.resource.form_id}&clientId=${form.resource.client.user_id_number}`}
				target="_blank"
			>
				<small>view form</small>
			</Link>
			<OverlayTrigger overlay={
				<Tooltip>Discuss this custom form in the chat</Tooltip>
			}>
				<DiscussResourceButton
					className="text-info"
					style={{
						border:'none',
						background:'none'
					}}
					pendingText="linking"
					user_id_number={form.resource.client.user_id_number}
					name={form.resource.form_title}
					id={form.resource.form_id}
					type="custom_form"
				>
					<small>discuss</small>
				</DiscussResourceButton>
			</OverlayTrigger>
			<small className="text-muted">
				{new Date(form.datetime.split(' ').join('T')).toLocaleString([],dateOptions)}
			</small>
		</div>
	</div>)
}

const EventComment = ({event})=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	return (
		<div>
			<div className={styles.ItemHeader}>
				{!isClient?
					<>
						{Boolean(event.user_profile_pic)&&
							<UserThumbnail 
								src={event.user_profile_pic}
							/>
						}
						<strong>{event.client_user_name}</strong>
						<span className="mx-1">commented on {event.event_type}</span>
						<strong>{event.note}</strong>
					</>
					:
					<>
						New comments on your {event.event_type} <strong>{event.note}</strong>
					</>
				}
			</div>
			<div>
				<small>{event.client_note}</small>
			</div>
			<hr className="my-1"/>
			<div className="d-flex justify-content-between">
				<EventLink
					eventType={event.event_type}
					display={event.event_id}
					client={event.client_id}
				/>
				<OverlayTrigger overlay={
					<Tooltip>Discuss this {event.event_type} in the chat</Tooltip>
				}>
					<DiscussResourceButton
						className="text-info"
						style={{
							border:'none',
							background:'none',
							fontSize:'14px'
						}}
						pendingText="linking"
						user_id_number={event.client_id}
						name={event.note}
						id={event.event_id}
						type={event.event_type}
					>
						Discuss
					</DiscussResourceButton>
				</OverlayTrigger>
				{Boolean(event.notes_updated_on) && 
					<small className="text-muted">
						{new Date(event.notes_updated_on.split(' ').join('T')).toLocaleString([],dateOptions)}
					</small>
				}
			</div>
		</div>
	)
}

const CompletedEvent = ({event})=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	return (
		<div>
			<div className={styles.ItemHeader}>
				{!isClient?
					<>
						{Boolean(event.resource.user_profile_pic)&&
							<UserThumbnail src={event.resource.user_profile_pic}/>
						}
						<strong>{event.resource.client_user_name}</strong> completed {event.resource.event_type} <strong>{event.resource.note}</strong>
					</>
					:
					<>
						You completed {event.resource.event_type} <strong>{event.resource.note}</strong>
					</>
				}
			</div>
			<hr className="my-1"/>
			<div className="d-flex justify-content-between align-items-end">
				<EventLink
					eventType={event.resource.event_type}
					display={event.resource.event_id}
					client={event.resource.client_id}
				/>
				<OverlayTrigger overlay={
					<Tooltip>Discuss this {event.event_type} in the chat</Tooltip>
				}>
					<DiscussResourceButton
						className="text-info"
						style={{
							border:'none',
							background:'none',
							fontSize:'14px'
						}}
						pendingText="linking"
						user_id_number={event.resource.client_id}
						name={event.resource.note}
						id={event.resource.event_id}
						type={event.resource.event_type}
					>
						Discuss
					</DiscussResourceButton>
				</OverlayTrigger>
				<small className="text-muted">
					{new Date(event.datetime.split(' ').join('T')).toLocaleString([],dateOptions)}
				</small>
			</div>
		</div>
	)
}

const AddedEvent = ({event})=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	return (
		<div>
			<div className={styles.ItemHeader}>
				{!isClient&&Boolean(event.resource.user_profile_pic)&&
					<UserThumbnail src={event.resource.user_profile_pic}/>
				}
				{capitalize(event.resource.event_type)} <strong>{event.resource.note}</strong> was added to
				{!isClient?
					<strong className="ml-1">{event.resource.client_user_name}</strong> 
					:
					<span className="ml-1">your account</span>
				}
			</div>
			<hr className="my-1"/>
			<div className="d-flex justify-content-between align-items-end">
				<EventLink
					eventType={event.resource.event_type}
					display={event.resource.event_id}
					client={event.resource.client_id}
				/>
				<OverlayTrigger overlay={
					<Tooltip>Discuss this {event.event_type} in the chat</Tooltip>
				}>
					<DiscussResourceButton
						className="text-info"
						style={{
							border:'none',
							background:'none',
							fontSize:'14px'
						}}
						pendingText="linking"
						user_id_number={event.resource.client_id}
						name={event.resource.note}
						id={event.resource.event_id}
						type={event.resource.event_type}
					>
						Discuss
					</DiscussResourceButton>
				</OverlayTrigger>
				<small className="text-muted">
					{new Date(event.datetime.split(' ').join('T')).toLocaleString([],dateOptions)}
				</small>
			</div>
		</div>
	)
}

const RecentPayment = ({payment})=>(
	<div>
		<div>
			{Boolean(payment.client.profile_pic)&&
				<UserThumbnail src={payment.client.profile_pic}/>
			}
			<strong>{payment.client.user_name}</strong> paid <strong>{getCurrencySymbol(payment.currency.ISO)}{payment.amount} ({payment.currency.ISO})</strong>
		</div>
		<hr className="my-1"/>
		<div className="d-flex justify-content-between align-items-end">
			<Link to={`/paymentsDashboard`} target="_blank">
				<small>View Payments</small>
			</Link>
			<OverlayTrigger overlay={
					<Tooltip>Discuss this payment in the chat</Tooltip>
				}>
					<DiscussResourceButton
						className="text-info"
						style={{
							border:'none',
							background:'none',
							fontSize:'14px'
						}}
						pendingText="linking"
						user_id_number={payment.client.user_id_number}
						name="payment"
						id={payment.paymentID}
						type="payment"
					>
						Discuss
					</DiscussResourceButton>
				</OverlayTrigger>
			<small className="text-muted">
				{new Date(payment.date).toLocaleDateString()}
			</small>
		</div>
	</div>
)

const ClassSignup = ({signup})=>{
	const isClient = useCurrentUser().account_type === 'client'
	return (
		<div>
			<div className={styles.ItemHeader}>
				{!isClient?
					<>
						{Boolean(signup.resource.client.profile_pic)&&
							<UserThumbnail src={signup.resource.client.profile_pic}/>
						}
						{Boolean(signup.resource.client.user_name)&&
							<>
								<strong>{signup.resource.client.user_name}</strong>
								<span className="mx-1">registered for</span>
							</>
						}
					</>
					:
					<span className="mr-1">
						You registered for
					</span>
				}
				<strong>{signup.resource.title}</strong> 
			</div>
			<hr className="my-1"/>
			<div className="d-flex justify-content-between align-items-end">
				<Link to="/classes" target="_blank">
					<small>view classes</small>
				</Link>
				<OverlayTrigger overlay={
					<Tooltip>Discuss this class in the chat</Tooltip>
				}>
					<DiscussResourceButton
						className="text-info"
						style={{
							border:'none',
							background:'none',
						}}
						pendingText="linking"
						user_id_number={signup.resource_meta.client_id}
						name={signup.resource.title}
						id={signup.resource._id}
						type="live_class"
					>
						<small>Discuss</small>
					</DiscussResourceButton>
				</OverlayTrigger>
				<small>
					{new Date(signup.datetime.split(' ').join('T')).toLocaleString([],dateOptions)}
				</small>
			</div>
		</div>
	)
}

const ScheduledMessage = ({message})=>(
	<div>
		<div>
			<strong>Sent:</strong> {message.resource.message}
		</div>
		<hr className="my-1"/>
		<div className="text-right">
			<small>
				sent @ {new Date(message.datetime.split(' ').join('T')).toLocaleString([],dateOptions)}
			</small>
		</div>
	</div>
)

const ExerciseResultVideo = ({exerciseSet})=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	return (
		<div>
			<div className={styles.ItemHeader}>
				{!isClient&&Boolean(exerciseSet.resource.client.profile_pic)&&
					<UserThumbnail src={exerciseSet.resource.client.profile_pic.url}/>
				}
				{!isClient?
					<strong className="mr-1">{exerciseSet.resource.client.user_name}</strong> 
					:
					<span className="mr-1">You</span>
				}
				added exercise progress video to exercise <strong>{exerciseSet.resource.exercise.exercise_name}</strong> on workout <strong>{exerciseSet.resource.workout.note}</strong>
			</div>
			<video 
				src={exerciseSet.resource.result_video_url}
				className="w-100 rounded"
				controls
			/>
			<hr className="my-1"/>
			<div className="d-flex justify-content-between align-items-end">
			
				<EventLink
					eventType="workout"
					display={exerciseSet.resource.workout.event_id}
					client={exerciseSet.resource.workout.client_id}
				/>
				<OverlayTrigger overlay={
					<Tooltip>Discuss this workout in the chat</Tooltip>
				}>
					<DiscussResourceButton
						className="text-info"
						style={{
							background:'none',
							fontSize:'14px',
							border:'none',
						}}
						pendingText="linking"
						user_id_number={exerciseSet.resource.workout.client_id}
						name={exerciseSet.resource.workout.note}
						id={exerciseSet.resource.workout.event_id}
						type={exerciseSet.resource.workout.event_type}
					>
						Discuss
					</DiscussResourceButton>
				</OverlayTrigger>
				<small className="text-muted">
					{new Date(exerciseSet.datetime.split(' ').join('T')).toLocaleString([],dateOptions)}
				</small>
			</div>
		</div>
	)
}

const ProspectClient = ({prospect})=>{
	const setProspectViewer = useSetProspectViewer()
	return (
		<div>
			<strong>Email:</strong> {prospect.resource.user_id}
			<br/>
			<strong>Name:</strong> {prospect.resource.user_name}
			<br/>
			<Button 
				onClick={setProspectViewer.bind(null,{show:true,id:prospect.resource.user_id_number,mode:'view'})}
				variant="outline-primary"
				size="sm"
			>
				View Profile
			</Button>
		</div>
	)
}

const ItemComponent = ({item,type})=>{
	//these types are able to have reactions
	const canReact = (new Set([
		'class_signup',
		'progress_pic_added',
		'event_completed',
		'event_added',
		'form_added',
		'form_completed',
		'calendar_updated',
		'exercise_result_video_added'
	])).has(type)
	const [userReaction,setUserReaction] = useState(canReact?item.reaction_data.recipient_reaction:null)
	const [reactionMap,setReactionMap] = useState(canReact?item.reaction_data.reaction_map:{})
	const resolve = ()=>{
		switch(type){
			case 'class_signup': return <ClassSignup signup={item}/>
			case 'payments': return <RecentPayment payment={item}/>
			case 'event_completed': return <CompletedEvent event={item}/>
			case 'event_notes': return <EventComment event={item}/>
			case 'form_completed': return <CompletedForm form={item}/>
			case 'calendar_updated': return <CalendarUpdated event={item}/>
			case 'chat': return <ChatItem item={item}/>
			case 'progress_pic_added': return <ProgressPic pic={item}/>
			case 'event_added': return <AddedEvent event={item}/>
			case 'form_added': return <AddedForm form={item}/>
			case 'scheduled_message_sent': return <ScheduledMessage message={item}/>
			case 'exercise_result_video_added': return <ExerciseResultVideo exerciseSet={item} />
			case 'prospective_client_added': return <ProspectClient prospect={item}/>
			default: return (
				<div className="mt-2 p-2 rounded border">
					todo: {type}
				</div>
			)
		}
	}
	const onReaction = (reaction)=>{
		setReactionMap(prev=>{
			//preform deep copy
			const update = JSON.parse(JSON.stringify(prev))
			if(userReaction!=='none'){
				update[userReaction].count -= 1
			}
			update[reaction.id].count += 1
			return update
		})
		setUserReaction(reaction.id)
		envAwarePost('api/notifications/api/',{
			action:'reactToNotification',
			notification_type:item.type,
			notification_id:item.id,
			reaction_id:reaction.id,
		})
	}
	return (
		<div className="mt-2 p-2 rounded border position-relative">
			{resolve()}
			{canReact&&
				<div className="mt-1 d-flex justify-content-between align-items-center">
					<RemoveButton id={item.id}/>
					<Reactions onReaction={onReaction} reactions={reactionMap}/>
				</div>
			}
		</div>
	)
}

const Section = ({type,items,showNewBadge,endNewIdx})=>{
	const heading = {
		class_signup:'Class Signups',
		progress_pic_added:'New Progress Pics',
		chat:'Chat Updates',
		event_completed:'Completed Events',
		payments:'Recent Payments',
		form_completed:'Completed Forms',
		event_notes:'New Event Comments',
		event_added:'New Events',
		form_added:'New Form Assigned',
		scheduled_message_sent:'Automated Messages',
		calendar_updated: "Calendar Updates",
		exercise_result_video_added:'Exercise Result Video Added',
		prospective_client_added:'New Prospective Client'
	}[type]

	const icon = {
		class_signup:'fa-star',
		progress_pic_added:'fa-image',
		chat:'fa-comments',
		event_completed:'fa-check',
		payments:'fa-money-bill',
		form_completed:'fa-clipboard-check',
		event_notes:'fa-comment',
		event_added:'fa-plus',
		form_added:'fa-clipboard-list',
		scheduled_message_sent:'fa-mail-bulk',
		calendar_updated: 'fa-calendar-alt',
		exercise_result_video_added:'fa-video',
		prospective_client_added:'fa-users',
	}[type]
	return (
		<div>
			<div>
				<strong className={styles.SectionHeading}>
					<i className={`fa ${icon} mr-1`}/>
					{heading}
					{showNewBadge&&
						<Badge className="ml-2" variant="danger">NEW</Badge>
					}
				</strong>
			</div>
			<div>
				{items.map((item,i)=>(
					<div key={i}>
						<ItemComponent key={`${type}-${i}`} item={item} type={type}/>
						{(i===endNewIdx&&endNewIdx<items.length-1)&&
							<div className="text-center text-muted position-relative mt-2" style={{fontSize:'12px',lineHeight:'12px'}}>
								<div style={{
									background:'#ddd',
									height:'1px',
									width:'100%',
									position:'absolute',
									top:'50%',
									left:0,
									transform:'translateY(-50%)',
									zIndex:-1
								}}/>
								<span className="bg-white px-2">end new activity</span>
							</div>
						}
					</div>
				))}
			</div>
		</div>
	)
}

const NotificationDashboard = ()=>{
	const dispatch = useDispatch()
	const [status,setStatus] = useState('pending')
	const sections = useSelector(state=>state.notificationDashboard.sections)
	const {isMAXUser} = useCurrentUser()

	const fetch = ()=>{
		return dispatch(getActivityLog())
	}

	useEffect(()=>{
		fetch().then( res => {
			setStatus('idle')
		})
		dispatch(getReactionOptions())
	},[])

	const refresh = ()=>{
		setStatus('refreshing')
		fetch().then( res => {
			setStatus('idle')
		})
	}

	const [bulkReactStatus,setBulkReactStatus] = useState('idle')

	const handleReactInBulk = (reaction)=>{
		setBulkReactStatus('pending')
		dispatch(reactInBulk(reaction.id)).then(()=>{
			setBulkReactStatus('idle')
		})
	}

	const [clearStatus,setClearStatus] = useState('idle')
	const clearAll = async ()=>{
		if(!window.confirm('Are you sure you want to clear all old notifications?')) return
		setClearStatus('pending')
		dispatch(clearAllNotifications()).then(()=>{
			setClearStatus('idle')
		})
	}

	//only show sections that have items
	const sectionComponents = sections.map(({type,items,has_new,last_new_item_idx,id},i)=>(
		<Section 
			key={`${type}-${id}`}
			type={type}
			items={items}
			showNewBadge={
				last_new_item_idx >- 1 ||
				['event_notes','chat'].includes('type')
			}
			endNewIdx={last_new_item_idx}
		/>
	)).filter( s => s.props.items.length > 0 )

	return (
		<div className="pt-2 px-2 px-md-3">
			{status==='pending'?
				<div className="d-flex p-5 align-items-center justify-content-center">
					<div className="text-center">
						<h2>Fetching Activity Log</h2>
						<Spinner animation="border"/>
					</div>
				</div>
				:
				<div>
					<div className="d-flex align-items-center justify-content-between flex-wrap">
						<h2>Recent Activity</h2>
						<div className="d-flex align-items-center">
							<span className="mr-1">
								<Reactions
									disabled={bulkReactStatus==='pending'}
									onReaction={handleReactInBulk}
									reactions={{}}
								>
									{bulkReactStatus==='pending'?
										<Spinner className="mr-1" size="sm" animation="border"/>
										:
										<span className="mr-1">Bulk React</span>
									}
								</Reactions>
							</span>
							<Button 
								disabled={clearStatus === 'pending'} 
								variant="outline-danger"
								onClick={clearAll}
								className="mr-1"
								size="sm"
							>
								<i className="fas fa-times mr-1"/>
								Clear Seen {clearStatus === 'pending'&& <Spinner animation="border" size="sm"/>}
							</Button>
							<Button 
								disabled={status === 'refreshing'} 
								variant="outline-primary"
								onClick={refresh}
								size="sm"
							>
								<i className="fas fa-redo mr-1"/>
								Refresh {status === 'refreshing'&& <Spinner animation="border" size="sm"/>}
							</Button>
						</div>
					</div>
					<hr/>
					{sectionComponents.length === 0?
						<div className="text-center">
							<strong>Nothing new to report</strong>
						</div>
						:
						<ResponsiveMasonry columnsCountBreakPoints={{350: 1, 900: 2, 1200: 3, 1800:4}}>
							<Masonry gutter="16px">
								{sectionComponents}
							</Masonry>
						</ResponsiveMasonry>
					}
				</div>
			}
		</div>
	)
}

export default NotificationDashboard